import React from 'react';
import { useTranslation } from 'react-i18next';
import { Users, CalendarCheck, X } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';

const AffectationsActionBar = ({ selectedEmployees, handleOpenAssignModal, confirmUnassign, onClearSelection }) => {
  const { t } = useTranslation();

  if (selectedEmployees.length === 0) return null;

  return (
    <Card className="border-primary/40 bg-primary/5">
      <CardContent className="pt-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Users className="h-5 w-5 text-muted-foreground" />
            <span className="font-medium text-foreground">
              {t('holidayAssignments.actionBar.selected', { count: selectedEmployees.length })}
            </span>
          </div>
          <div className="flex items-center gap-2">
            <Button onClick={handleOpenAssignModal}>
              <CalendarCheck className="mr-2 h-4 w-4" />
              {t('holidayAssignments.assign.title')}
            </Button>
            <Button onClick={confirmUnassign} variant="outline" className="border-red-900/40 text-red-400 hover:bg-red-950/20">
              <X className="mr-2 h-4 w-4" />
              {t('holidayAssignments.unassign.submit')}
            </Button>
            <Button variant="ghost" onClick={onClearSelection}>{t('common.cancel')}</Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default AffectationsActionBar;
